import React from 'react';
import { Container, Box } from '@hover/blueprint';
import ChooseThePlanHeader from './ChooseThePlanHeader';
import PricingTable from './PricingTable';
import ChooseThePlanFooter from './ChooseThePlanFooter';

const ChooseThePlan: React.FC = () => (
  <Box bg="brandTan.100" alignItems="center" w="100%">
    <Container bg="brandTan.100" maxW="1248px" centerContent px={0}>
      <ChooseThePlanHeader />
      <PricingTable />
      <ChooseThePlanFooter />
    </Container>
  </Box>
);

export default ChooseThePlan;
